import { render } from "./LeaveApprovalLoader.vue?vue&type=template&id=0ccf0eb6"
import script from "./LeaveApprovalLoader.vue?vue&type=script&lang=js"
export * from "./LeaveApprovalLoader.vue?vue&type=script&lang=js"

import "./LeaveApprovalLoader.vue?vue&type=style&index=0&id=0ccf0eb6&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__